(() => {
  const productVariantsParent = document.querySelector(".js-product-variants-parent");
  const firstGridImage = document.querySelector(".product-media-gallery__grid-image1 img");

  const initalImage = { src: firstGridImage.src, srcset: firstGridImage.scrset };

  function switchImage(newImage) {
    if (firstGridImage) {
      firstGridImage.src = newImage.src;
      firstGridImage.srcset = newImage.src;
    }
  }

  function handleVariantSwitch(e) {
    const checkedInput = e.target;
    if (checkedInput.checked) {
      const scriptElement = document.querySelector(
        `script[type="application/json"][data-resource="${checkedInput.id}"]`
      );
      if (scriptElement) {
        const jsonContent = scriptElement.textContent;
        const parsedData = JSON.parse(jsonContent);
        if (parsedData?.featured_image) {
          switchImage(parsedData.featured_image);
        }
      }
    }
  }
  if (productVariantsParent) {
    productVariantsParent.addEventListener("change", (event) => {
      handleVariantSwitch(event);
    });
  }
})();
